/** @format */
/**
 * ViewCalendarAnnotazioni.tsx
 *
 * Pagina dedicata alle annotazioni calendario.
 * Stessa struttura di ViewGridDailyShift / ViewReportPresences.
 * Da registrare nel router e nel menu navigazione.
 */

import React from "react";
import { Col, Row } from "antd";
import { BaseColor } from "../../../theme/maps/Colors";
import { UITitle } from "../../ui/Title";
import UITransition from "../../ui/Transition";
import { CalendarAnnotation } from "./calendar";

export const ViewCalendarAnnotazioni = (): JSX.Element => {
    return (
        <>
            <UITransition>
                <Row justify="space-between" align="middle" gutter={[16, 16]}>
                    <Col style={{ display: "inline-flex", alignItems: "baseline" }}>
                        <UITitle level={2} color={BaseColor}>
                            Post-it
                        </UITitle>
                    </Col>
                </Row>

                <CalendarAnnotation />
            </UITransition>
        </>
    );
};
